export default __webpack_public_path__ + "static/media/D.87560e84.svg";